export const SHOW_DIALOG = 'SHOW_DIALOG';
export const HIDE_DIALOG = 'HIDE_DIALOG';

export function showDialog(name, context) {
  return {
    type: SHOW_DIALOG,
    name,
    context,
  };
}

export function hideDialog(name) {
  return {
    type: HIDE_DIALOG,
    name,
  };
}

export function showAlert(title, message, type) {
  return showDialog('alert', {
    title,
    message,
    type,
  });
}

export function showError(title, message) {
  return showAlert(title, message, 'severe');
}

export function showWarning(title, message) {
  return showAlert(title, message, 'warning');
}

export function isDialogOpen(dialogs, name) {
  return dialogs && dialogs[name] && dialogs[name].open ? true : false;
}



// WEBPACK FOOTER //
// ./src/actions/dialogs.js